__turbopack_context__.v({
  "root": "Textarea-module__9uZ_cq__root",
  "textarea": "Textarea-module__9uZ_cq__textarea",
});
